import { http, HttpResponse } from "msw";
import { ApiCatalog, API_BASE_URL } from "@/api";
import getParsedURL from "@/api/utils/getParsedURL";
import { NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE } from "@/constants/TRIAL_LICENSE_CAMPAIGNS";
import { License } from "@/types/models";

export const mockUserLicenses: License[] = [
  {
    id: 1,
    product: "collections",
    date_starts: "2023-10-25T04:00:00Z",
    date_ends: "2024-10-25T03:59:59Z",
    is_active: true,
    is_expired: false,
    is_trial: false,
    campaign: null,
    collection_ids: ["testid"],
    type: "subscription",
  },
  {
    id: 2,
    product: "power_words",
    date_starts: "2023-10-25T17:58:37Z",
    date_ends: "2024-10-24T17:58:37Z",
    is_active: true,
    is_expired: false,
    is_trial: true,
    campaign: NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE,
    collection_ids: ["testid2"],
    type: "campaign",
  },
];

export const LICENSES_ENDPOINT_URL = `${API_BASE_URL}${getParsedURL(
  ApiCatalog.license.endpoint,
  [{ id: "me" }],
)}`;

export const getMswLicensesServerHandler = (mockOverride?: License[]) => {
  return http.get(LICENSES_ENDPOINT_URL, () => {
    return HttpResponse.json(mockOverride || mockUserLicenses, { status: 200 });
  });
};
